// extracted by mini-css-extract-plugin
export var content = "strapi-location-panel-module--content--67536";
export var map = "strapi-location-panel-module--map--b7670";
export var root = "strapi-location-panel-module--root--e2fd0";
export var schoolsListWrapper = "strapi-location-panel-module--schoolsListWrapper--20ac7";
export var title = "strapi-location-panel-module--title--e65f8";